import React from "react";
import usePushNotifications from "../api/usePushNotifications";

const Loading = ({ loading }) =>
  loading ? (
    <div className="app-loader">Traitement en cours, veuillez patienter...</div>
  ) : null;
const Error = ({ error }) =>
  error ? (
    <section className="app-error">
      <h2>{error.name}</h2>
      <p>Error message : {error.message}</p>
      <p>Error code : {error.code}</p>
    </section>
  ) : null;

export default function PushNotification() {
  const {
    userConsent,
    pushNotificationSupported,
    userSubscription,
    onClickAskUserPermission,
    onClickSusbribeToPushNotification,
    onClickSendSubscriptionToPushServer,
    pushServerSubscriptionId,
    onClickSendNotification,
    error,
    loading,
  } = usePushNotifications();

  const isConsentGranted = userConsent === "granted";
  const isConsentDenied = userConsent === "denied";

  return (
    <main>
      <Loading loading={loading} />

      <Error error={error} />

      {!isConsentDenied && !isConsentGranted && (
        <button onClick={onClickAskUserPermission}>
          Cliquez ici pour activer les notifications
        </button>
      )}

      {isConsentGranted && !pushServerSubscriptionId && (
        <div>
          <button onClick={onClickSusbribeToPushNotification}>
            Cliquez ici pour vous abonner aux notifications
          </button>
        </div>
      )}

      {isConsentGranted && pushServerSubscriptionId && (
        <div>
          <p>Vous êtes abonné aux notifications !</p>
        </div>
      )}
    </main>
  );
}
